import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { LiraRunAdvScript } from '@sbt-web/adv';
import ErrorBoundary from '@sbt-web/error-boundary';
import type { AdItem, CarInfo } from '@sbt-web/network/types';
import { createSkyscraperSizeConstraints } from '@/client/components/Adv/Lira/createSkyscraperSizeConstraints';
import { getDesktopFallbackConfig, getMsiteFallbackConfig } from '@/client/components/Adv/Lira/fallbackConfig/adView';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
import { useGetVerticalByCategoryId } from '@/client/components/Adv/Lira/LiraRunAdvScriptWrapper/useGetVerticalByCategoryId';
import { targetingForAd } from '@/client/components/Adv/Lira/targeting/forAd';
const adtest = process.env.NEXT_PUBLIC_INTERNAL_ENVIRONMENT === 'prod' ? 'off' : 'on';
type Props = {
  ad: AdItem;
  infocarData?: CarInfo | null;
};
const LiraWrapper = t0 => {
  const $ = _c(29);
  const {
    ad,
    infocarData
  } = t0;
  const vertical = useGetVerticalByCategoryId(ad.category.id);
  let t1;
  if ($[0] !== vertical) {
    t1 = getDesktopFallbackConfig(vertical);
    $[0] = vertical;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fallbackConfigDesktop = t1;
  let t2;
  if ($[2] !== vertical) {
    t2 = getMsiteFallbackConfig(vertical);
    $[2] = vertical;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const fallbackConfigMsite = t2;
  let t3;
  if ($[4] !== ad || $[5] !== infocarData) {
    t3 = targetingForAd(ad, infocarData);
    $[4] = ad;
    $[5] = infocarData;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const targeting = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createSkyscraperSizeConstraints(LiraContainerIds.adView.skyscraperLeft, LiraContainerIds.adView.skyscraperRight);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      isLazyLoad: true
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      isLazyLoad: true
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      isLazyLoad: true
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      isLazyLoad: true
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      isLazyLoad: true
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      isLazyLoad: true
    };
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      isLazyLoad: true
    };
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      isLazyLoad: true
    };
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      isLazyLoad: true
    };
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      isLazyLoad: true
    };
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      ...t4,
      [LiraContainerIds.adView.sponsorGallery]: t5,
      [LiraContainerIds.adView.anchorGallery]: t6,
      [LiraContainerIds.adView.imageIntoGalleryForPro]: t7,
      [LiraContainerIds.adView.replyBox]: t8,
      [LiraContainerIds.adView.videoPreroll]: t9,
      [LiraContainerIds.adView.imageIntoGalleryForPrivateMsite]: t10,
      [LiraContainerIds.adView.imageIntoGalleryForPrivate]: t11,
      [LiraContainerIds.adView.imageIntoGalleryForProMsite]: t12,
      [LiraContainerIds.adView.belowGallery]: t13,
      [LiraContainerIds.adView.bottom]: t14,
      [LiraContainerIds.adView.vehicleHistory]: {
        isLazyLoad: true
      }
    };
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  const constraintsByContainerId = t15;
  let t16;
  if ($[19] !== fallbackConfigDesktop || $[20] !== fallbackConfigMsite) {
    t16 = {
      msite: fallbackConfigMsite,
      desktop: fallbackConfigDesktop
    };
    $[19] = fallbackConfigDesktop;
    $[20] = fallbackConfigMsite;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== ad.subject) {
    t17 = {
      adtest,
      query: ad.subject
    };
    $[22] = ad.subject;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t16 || $[25] !== t17 || $[26] !== targeting || $[27] !== vertical) {
    t18 = <LiraRunAdvScript vertical={vertical} pageType="adview" env={process.env.NEXT_PUBLIC_INTERNAL_ENVIRONMENT} fallbackHebeConfig={t16} adsense={t17} constraintsByContainerId={constraintsByContainerId} targeting={targeting} />;
    $[24] = t16;
    $[25] = t17;
    $[26] = targeting;
    $[27] = vertical;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  return t18;
};
export const LiraRunAdvScriptWrapperForAdview = t0 => {
  const $ = _c(3);
  const {
    ad,
    infocarData
  } = t0;
  let t1;
  if ($[0] !== ad || $[1] !== infocarData) {
    t1 = <ErrorBoundary><LiraWrapper ad={ad} infocarData={infocarData} /></ErrorBoundary>;
    $[0] = ad;
    $[1] = infocarData;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};